<template>
  <div class="tab-content">
    <!-- 基本信息内容 -->
    <div class="basic-info-section">
      <!-- 测试类型区域 -->
      <div class="info-area">
        <h3 class="area-title">基本信息</h3>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">申请编号：</span>
            <span class="info-value">{{ applicationInfo.applicationNo || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">申请主体：</span>
            <span class="info-value">{{ applicationInfo.deptName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">申请车辆：</span>
            <span class="info-value">{{ applicationInfo.vin || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">申请时间：</span>
            <span class="info-value">{{ applicationInfo.createTime || '-' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">申请类型：</span>
            <span class="info-value">
              {{ applicationInfo.categoryName }}
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">状态：</span>
            <span class="info-value">{{ getStatusView(applicationInfo.status) }}</span>
          </div>
        
          <div class="info-item">
            <span class="info-label">开始时间：</span>
            <span class="info-value">{{ applicationInfo.startDate || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">结束时间：</span>
            <span class="info-value">{{ applicationInfo.endDate || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 测试区域区域 -->
      <div class="info-area">
        <h3 class="area-title">测试区域</h3>
        <a-table 
          :columns="zoneRouteColumns" 
          :data-source="testAreaRoutes" 
          :pagination="false"
          rowKey="id"
          size="middle"
        />
<!--        <Button type="dashed" style="width: 100%; margin: 10px 0; padding: 8px 5px; font-size: 16px; text-align: center; line-height: 24px;">-->
<!--          + 添加测试区域-->
<!--        </Button>-->
      </div>
    </div>
  </div>
</template>

<script setup name="BasicInfoTab">
import {defineProps, onMounted, ref} from 'vue';
import {getStatusView} from '@/utils/applicationUtils'
import {getApplicationById} from "@/api/application/testApplication";
import { getApplicationRoutesByApplicationId } from "@/api/application/applicationRoutes";
import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const props = defineProps({
  id: {
    type: String,
    required: true
  }
});

// 测试基本信息
const applicationInfo = ref({});

// 测试区域数据
const testAreaRoutes = ref([]);

// 测试区域表格列定义
const zoneRouteColumns = [
  {
    title: '测试区域',
    dataIndex: 'areaName',
    key: 'areaName',
    width: 400
  },
  {
    title: '测试路线',
    dataIndex: 'routeName',
    key: 'routeName'
  }
];

const getInfo = async () => {
  getApplicationById(props.id).then((res) => {
    applicationInfo.value = res.data;
  });
}

const getRoutes = async () => {
  
  getApplicationRoutesByApplicationId(props.id).then((res) => {
    testAreaRoutes.value = res.data;
  });
}

// 组件挂载时获取数据
onMounted(async () => {
  try {
    await getInfo(props.id);
    await getRoutes(props.id);
  } catch (error) {
    console.error('获取基本信息失败:', error);
  }
});
</script>

<style scoped>
.tab-content {
  background: #fff;
  margin-bottom: 80px;
}

.basic-info-section {
  background: #fff;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
}

.info-area {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #fafafa;
}

.area-title {
  margin-top: 0;
  padding-bottom: 5px;
  border-bottom: 2px solid #d9d9d9;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.info-label {
  width: 100px;
  font-size: 15px;
}

.info-value {
  flex: 1;
  color: #333;
  word-break: break-all;
  font-size: 15px;
}

/* 确保表格样式合适 */
:deep(.ant-table) {
  margin-top: 10px;
}

:deep(.ant-table-thead > tr > th) {
  background-color: #fafafa;
  font-weight: 600;
  color: #333;
}
</style>